export default __webpack_public_path__ + "static/media/Tabl_20.5a980894.svg";